const BrazilFlag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='currentColor' {...props}>
    <g clipPath='url(#clip0_1061_64431)'>
      <path
        d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z'
        fill='#6DA544'
      />
      <path d='M8.00029 3.13037L14.609 7.99993L8.00029 12.8695L1.3916 7.99993L8.00029 3.13037Z' fill='#FFDA44' />
      <path
        d='M8.00037 10.7825C9.53715 10.7825 10.783 9.53666 10.783 7.99988C10.783 6.46309 9.53715 5.21729 8.00037 5.21729C6.46358 5.21729 5.21777 6.46309 5.21777 7.99988C5.21777 9.53666 6.46358 10.7825 8.00037 10.7825Z'
        fill='#F0F0F0'
      />
      <path
        d='M6.60916 7.82617C6.12528 7.82617 5.65831 7.89977 5.21875 8.03633C5.23822 9.55633 6.47584 10.7827 8.00047 10.7827C8.94322 10.7827 9.77584 10.3134 10.2792 9.5962C9.41803 8.51817 8.093 7.82617 6.60916 7.82617Z'
        fill='#0052B4'
      />
      <path
        d='M10.7314 8.533C10.7649 8.36038 10.783 8.18229 10.783 7.99988C10.783 6.46307 9.5372 5.21729 8.00042 5.21729C6.85373 5.21729 5.86936 5.91107 5.44336 6.90163C5.81992 6.8236 6.2098 6.7825 6.60914 6.7825C8.2253 6.78247 9.68736 7.45429 10.7314 8.533Z'
        fill='#0052B4'
      />
    </g>
    <defs>
      <clipPath id='clip0_1061_64431'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default BrazilFlag;
